import React from 'react'
import { Box, Grid } from '@material-ui/core'
import ArticleCardV2 from 'shared/cards/ArticleCard/ArticleCardV2'
import CircularProgress from '@material-ui/core/CircularProgress'
import ShowMoreButton from 'components/CTAAlert/ShowMoreButton/ShowMoreButton'
import { useStyles } from './ArticlesList_style'
import { JOB_INDEX_SEE_MORE_BUTTON } from 'assets/AlertsHelper'

const ArticlesList = (props) => {
    const { articles, type, user, loadingMore, loadMoreStatus, showMore } = props
    const classes = useStyles()
    return (
        <>
            <Grid container spacing={2} className={classes.articleGrid}>
                {articles.map((article, index) => {
                    return (
                        <Grid key={`article-card-${article.id}`} item lg={3} md={4} sm={6} xs={12}>
                            <ArticleCardV2 article={article} key={index} />
                        </Grid>
                    )
                })}
            </Grid>
            <ShowMoreButton
                type={type}
                user={user}
                origin={JOB_INDEX_SEE_MORE_BUTTON}
                loadingMore={loadingMore}
                loadMoreStatus={loadMoreStatus}
                showMoreAction={showMore}
            />
            {loadingMore && (
                <Box display='flex' justifyContent='center' fullWidth my={4}>
                    <CircularProgress color='primary' style={{ width: '80px', height: '80px' }} />
                </Box>
            )}
        </>
    )
}
export default ArticlesList
